<template>
  <div v-loading="isLoading">
    <el-card shadow="never">
      <EDI
        ref="edi"
        :form-data="carrier"
      />
    </el-card>
  </div>
</template>
<script>
import EDI from '@/components/Application/Manage/Carriers/Carrier/EDIConfiguration'
export default {
  components: {
    EDI
  },
  data () {
    return {
      title: 'EDI',
      breadcrumb: {
        name: 'EDI',
        route: { name: 'manage-carriers-carrier-configurations-edi' }
      },
      isSaving: false,
      isLoading: false,
      carrier: {},
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ]
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, builder => {
        builder.include = [
          'edi_connection'
        ]
      }).then(res => { this.carrier = res })
        .finally(() => { this.isLoading = false })
    },
    save () {
      this.isSaving = true
      this.carrier.update()
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
        })
    }
  }
}
</script>
